module.exports = __webpack_public_path__ + "img/strategy_img.09f2b08a.png";